/* eslint-disable no-nested-ternary */
import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import intl from "react-intl-universal";
import { withRouter } from "react-router-dom";
import { register } from "@/actions/auth";
import { Button, Form, Input, Select, message, Tooltip } from "antd";
import { registerSendCode, registerSendMobileCode } from "@/api/login";
import { getUrlParams } from "@/utils";
import Language from "@/components/Common/Language";
import logoImg from "@/assets/image/logo.png";
import ercode from "@/assets/image/ercode.png";
import styles from "./Register.module.scss";

type FieldType = {
  nickname?: string;
  email?: string;
  password?: string;
  emailVerifyCode?: string;
  invitationCode?: string;
  mobile?: string;
  industry?: string;
};

const { Option } = Select;

const Register = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [codeLoading, setCodeLoading] = useState(false);
  const [time, setTime] = useState(60);
  const buttonTime = useRef(null);
  const [code, setCode] = useState("");

  const getCode = () => {
    const code = getUrlParams("code");
    if (code) {
      form.setFieldsValue({ invitationCode: code });
      setCode(code);
    }
  };

  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  // useEffect(() => {
  //   if (isMobileDevice()) {
  //     window.location.href = `https://h5.9five.cn?invitationCode=${
  //       getUrlParams("code") || ""
  //     }`;
  //   }
  // }, []);

  useEffect(() => {
    if (form) {
      getCode();
    }
  }, [form]);

  if (time === 0) {
    clearInterval(buttonTime.current);
    buttonTime.current = null;
    setTime(60);
  }

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      await props.register({ ...values, type: "mobile" });
    } finally {
      setLoading(false);
    }
  };

  const sendEmail = async (email) => {
    setCodeLoading(true);
    try {
      const res = await registerSendCode({ email });
      if (res.code === 200) {
        message.success(intl.get("password_sendSuccess"));
        buttonTime.current = setInterval(() => {
          setTime((prevCount) => prevCount - 1);
        }, 1000);
      }
    } finally {
      setCodeLoading(false);
    }
  };

  const sendMobile = async (mobile) => {
    setCodeLoading(true);
    try {
      const res = await registerSendMobileCode({ mobile });
      if (res.code === 200) {
        message.success(intl.get("password_sendSuccess"));
        buttonTime.current = setInterval(() => {
          setTime((prevCount) => prevCount - 1);
        }, 1000);
      }
    } finally {
      setCodeLoading(false);
    }
  };

  const validatorPassword = (_rule, value) => {
    if (!value) {
      return Promise.reject(new Error(intl.get("password_enterPassword")));
    }
    // const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*(\d|[\W_])).{8,16}$/;
    const hasLowercase = /[a-z]/.test(value);
    const hasUppercase = /[A-Z]/.test(value);
    const hasDigit = /\d/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>+]/.test(value);

    const characterTypesCount = [
      hasLowercase,
      hasUppercase,
      hasDigit,
      hasSpecialChar,
    ].filter(Boolean).length;
    console.log(hasLowercase, hasUppercase, hasDigit, hasSpecialChar);
    if (characterTypesCount < 3 || value.length < 8 || value.length > 16) {
      return Promise.reject(new Error(intl.get("password_requirements")));
    }
    return Promise.resolve();
  };

  return (
    <>
      <div className={styles.content}>
        <div className={styles.contentForm}>
          <div className={styles.title}>
            <div className={styles.left}>
              <img src={logoImg} alt="" />
              {intl.get("registry_title")}
            </div>

            <div className={styles.langBox}>
              <Language />
            </div>
          </div>

          <Form
            name="basic"
            labelCol={{ span: 7 }}
            wrapperCol={{ span: 24 }}
            onFinish={onFinish}
            layout="vertical"
            autoComplete="off"
            form={form}
          >
            <Form.Item<FieldType>
              name="nickname"
              label={intl.get("registry_username")}
              rules={[
                { required: true, message: intl.get("registry_inputUsername") },
              ]}
            >
              <Input
                className={styles.loginIuput}
                allowClear
                placeholder={intl.get("registry_inputUsername")}
                readOnly={loading}
                count={{
                  show: true,
                  max: 20,
                }}
              />
            </Form.Item>
            <Form.Item<FieldType>
              name="mobile"
              label={intl.get("registry_phone")}
              rules={[
                {
                  required: true,
                  validator(_rule, value, callback) {
                    if (!value) {
                      callback(intl.get("sendEmail_validMobile"));
                    } else if (!/^[0-9]\d*$/.test(value)) {
                      callback(intl.get("sendEmail_validMobile"));
                    } else {
                      callback();
                    }
                  },
                },
              ]}
            >
              <Input
                className={styles.addonBeforeLoginIuput}
                placeholder={intl.get("registry_inputPhone")}
                readOnly={loading}
                allowClear
                addonBefore="+86"
              />
            </Form.Item>
            <Form.Item<FieldType>
              name="emailVerifyCode"
              label={intl.get("password_verificationCode")}
              rules={[
                {
                  required: true,
                  message: intl.get("password_inputVerificationCode"),
                },
              ]}
            >
              <div className={styles.loginIuputCode}>
                <Input
                  className={`${styles.loginIuput}`}
                  placeholder={intl.get("password_inputVerificationCode")}
                  readOnly={loading}
                  allowClear
                />
                <Button
                  className={styles.loginIuputBtn}
                  type="link"
                  loading={codeLoading}
                  disabled={buttonTime.current}
                  onClick={() => {
                    if (!form.getFieldValue("mobile")) {
                      return message.error(intl.get("password_emailRequired"));
                    }
                    sendMobile(form.getFieldValue("mobile"));
                  }}
                >
                  {buttonTime.current
                    ? `${time}s`
                    : intl.get("password_getVerificationCode")}
                </Button>
              </div>
            </Form.Item>

            <Form.Item<FieldType>
              name="password"
              label={intl.get("password_password")}
              rules={[
                {
                  required: true,
                  validator: validatorPassword,
                },
              ]}
            >
              <div>
                <Input.Password
                  className={styles.loginIuput}
                  placeholder={intl.get("password_inputPassword")}
                  readOnly={loading}
                  // allowClear
                />
                <p className={styles.pwdTips}>
                  {intl.get("password_requirements")}
                </p>
              </div>
            </Form.Item>

            <Form.Item<FieldType>
              name="invitationCode"
              label={intl.get("registry_invitCode")}
              rules={[
                {
                  required: false,
                  message: intl.get("registry_inputInvitCode"),
                },
              ]}
            >
              <div>
                <Input
                  className={styles.loginIuput}
                  placeholder={intl.get("registry_inputInvitCode")}
                  readOnly={loading}
                  // allowClear
                  value={code}
                  onChange={(e) => {
                    setCode(e.target.value);
                  }}
                />
                {/* <p className={styles.pwdTips}>
                  {intl.get("registry_noInviteCode")}
                  <Tooltip
                    color={"#fff"}
                    placement="top"
                    title={
                      <>
                        <img style={{ width: 140 }} src={ercode} alt="" />
                      </>
                    }
                    trigger="click"
                  >
                    <span>{intl.get("registry_addCustomerService")}</span>
                  </Tooltip>
                </p> */}
              </div>
            </Form.Item>

            <Form.Item<FieldType>
              name="email"
              label={intl.get("password_email")}
              rules={[
                { required: true, message: intl.get("password_inputEmail") },
                {
                  type: "email",
                  message: intl.get("sendEmail_validAddress"),
                },
              ]}
            >
              <Input
                className={styles.loginIuput}
                placeholder={intl.get("password_inputEmail")}
                readOnly={loading}
                allowClear
              />
            </Form.Item>

            <Form.Item<FieldType>
              name="industry"
              label={intl.get("registry_industry")}
              rules={[
                {
                  required: true,
                  message: intl.get("registry_selectIndustry"),
                },
              ]}
            >
              <Select
                className={styles.loginSelect}
                allowClear
                placeholder={intl.get("registry_selectIndustry")}
              >
                <Option value="TikTok博主">
                  {intl.get("registry_tiktokCreator")}
                </Option>
                <Option value="MCN机构">{intl.get("registry_mcn")}</Option>
                <Option value="广告服务商">
                  {intl.get("registry_adAgency")}
                </Option>
                <Option value="代运营服务商">
                  {intl.get("registry_operatingAgency")}
                </Option>
                <Option value="TikTok卖家">
                  {intl.get("registry_tiktokSeller")}
                </Option>
                <Option value="行业协会和商会">
                  {intl.get("registry_association")}
                </Option>
                <Option value="其它">{intl.get("registry_other")}</Option>
              </Select>
            </Form.Item>

            <div className={styles.registerTips}>
              {intl.get("registry_agreementPrefix")}
              <span
                onClick={() => {
                  window.open("/user.html", "_blank");
                }}
              >
                {intl.get("registry_userAgreement")}
              </span>
              {intl.get("registry_and")}
              <span
                onClick={() => {
                  window.open("/privacy.html", "_blank");
                }}
              >
                {intl.get("registry_privacyPolicy")}
              </span>
            </div>

            <Button
              className={styles.loginButton}
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              {intl.get("registry_register")}
            </Button>

            <div className={styles.tips}>
              {intl.get("registry_haveAccount")}
              <span
                onClick={() => {
                  window.location.href = "/login";
                }}
              >
                {intl.get("registry_goLogin")}
              </span>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default withRouter(connect(null, { register })(Register));
